/* eslint-disable react/require-default-props */
import clsx from 'clsx';
import React, { ForwardedRef, forwardRef, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '@/components/typography';
import { GLOBAL_TOOLTIP } from '@/constants/constants';

interface IProps {
  onClick: Function;
  label: string;
  icon: string | ReactNode;
  isSelected: boolean;
  disabled?: boolean;
  className?: string;
  containerClassName?: string;
  toolTip?: string;
}

const SideNavButtonOld = forwardRef(
  (
    {
      onClick,
      label,
      icon,
      isSelected,
      disabled = false,
      className = '',
      containerClassName = '',
      toolTip,
    }: IProps,
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <div
        className={containerClassName}
        data-tooltip-content={toolTip}
        data-tooltip-id={GLOBAL_TOOLTIP}
      >
        <button
          ref={ref}
          className={twMerge(
            'hover:border-r-1 hover:border-gray-20 hover:text-gray-100 ',
            isSelected
              ? 'border-r-2 border-green-50 bg-gray-20 text-gray-100 hover:border-r-2 hover:border-green-50 hover:bg-gray-30 md:border-b-0 md:border-r-2'
              : 'text-gray-70 hover:bg-gray-10',
            'relative z-80 flex h-[72px] w-[72px] cursor-pointer flex-col place-content-center items-center',
            disabled ? 'text-gray-50' : '',
            className
          )}
          disabled={disabled}
          type="button"
          onClick={(e) => onClick(e)}
        >
          {/* Icon */}
          <div
            className={clsx(
              'mb-1 h-5 w-5',
              disabled ? 'text-gray-50' : '',
              isSelected ? 'text-gray-100' : ''
            )}
          >
            {icon}
          </div>

          {/* Label */}
          <Typography
            className={twMerge(isSelected ? 'text-gray-100' : '')}
            variant="caption"
          >
            {label}
          </Typography>
        </button>
      </div>
    );
  }
);

export default SideNavButtonOld;
